import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { startSubmit } from 'redux-form';
import { getCurrentUserId } from '../../selectors/current-user-selectors';
import { getCategoryBySlug } from '../../selectors/categories-selectors';
import AppLoaded from '../../components/app-loaded';
import PostPageLayout from '../../components/post-page-layout';
import PostForm from '../../components/post-form';
import { createPost } from '../../actions/create-post';
import goBack from '../../actions/go-back';
import { openModal } from '../../actions/open-modal';
import { MODAL_TYPE_DISCARD_POST } from '../../constants/modal-types';
import { getFocusableContainerId } from '../../components/text-editor/modifiers/text-editor-utils';

export class PostCreatePage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      initialValues: { ownerId: props.ownerId, categoryId: props.categoryId },
    };
  }

  handleSubmit = post => this.props.createPost(post);

  handleCancel = isModified => {
    const { categorySlug } = this.props.params;
    if (isModified) {
      return this.props.openModal(MODAL_TYPE_DISCARD_POST, { categorySlug }, getFocusableContainerId('post'));
    } else {
      return this.props.goBack(`/${this.props.params.categorySlug}`);
    }
  };

  render() {
    const { categoryId, submit: handleSubmitButtonClick } = this.props;

    return (
      <PostPageLayout className="post-create-page">
        <PostForm
          onSubmit={this.handleSubmit}
          onSubmitButtonClick={handleSubmitButtonClick}
          onCancel={this.handleCancel}
          initialValues={this.state.initialValues}
          categoryId={categoryId}
        />
        <AppLoaded/>
      </PostPageLayout>
    );
  }
}

PostCreatePage.propTypes = {
  createPost: PropTypes.func.isRequired,
  goBack: PropTypes.func.isRequired,
  openModal: PropTypes.func.isRequired,
  submit: PropTypes.func.isRequired,
  ownerId: PropTypes.string.isRequired,
  categoryId: PropTypes.string,
  post: PropTypes.object,
  params: PropTypes.object,
};

const mapStateToProps = (state, ownProps) => ({
  ownerId: getCurrentUserId(state),
  categoryId: getCategoryBySlug(state, ownProps.params.categorySlug)._id,
});

const mapDispatchToProps = {
  createPost,
  submit: () => startSubmit('post'),
  goBack,
  openModal,
};

export default connect(mapStateToProps, mapDispatchToProps)(PostCreatePage);



// WEBPACK FOOTER //
// ./app/containers/post-create-page/post-create-page.js